import { Offcanvas } from "bootstrap";
import { createApp } from "vue";
import Store from "../Store";
import { toDate } from "./composant/b2bLangue";
import html from "./notifications.html";

const js = {
  url: function (echangeur) {},
  onLoad: async function (echangeur) {
    let THIS = this;

    class Notification {
      constructor(dateUpdated, id, rows) {
        this.rows = [];
        this.dateUpdated = dateUpdated;
        this.id = id;
      }
      async get() {
        /*
           @Dev
           Il faut prévoir la gestion du logout
        */

        // let hs = window.location.hash.split("/");
        // let h = null;

        // for (let hh of hs) if (hh.indexOf("&u=") > -1) h = hh.split("&u=")[1];


                
        let hs = (window.location.hash).split("/");
        let h = null;
        for (let hh of hs){
            //#orderVerifie&u=collection&env=collection&_ids=6644b1f1aeed35141829781e&ecran=delete
            if (!h && hh.indexOf('&u=') > -1) {
                let tt = hh.split('&');
                let t = tt.find(u=>u.indexOf("u=")>-1);
                if(t) h=t.split('u=')[1];
            }
        }


        let response = null;
        
        try{
          response= await THIS.rest("b2b.notif.get", { env: h });
        }catch(e){ 
          console.error("Erreur lors de la récupération des notifications",e);
        }


        console.log(response);
        // console.log("hash",h)

        if (response && response.ok)  this.rows = response.rows;
        if (!response || !response.ok) {
          Store.set("pingRunning", true);
          Store.set("ping", function () {});
        }
        //
        //
        //console.log("Notifications", this.rows);
        //
        //
        return this.rows;
      }
      async add(param) {
        const response = await THIS.rest("b2b.notif.create", {}, param);
        if (response.ok) this.rows = response.rows;
        return this.rows;
      }
      async update(param) {
        const response = await THIS.rest("b2b.notif.update", {}, param);
        if (response.ok) this.rows = response.rows;
        return this.rows;
      }
      async remove(param) {
        const response = await THIS.rest("b2b.notif.remove", {}, param);
        if (response.ok) this.rows = response.rows;
        return this.rows;
      }
      async removeAll() {
        const response = await THIS.rest("b2b.notif.removeAll", {});
        if (response.ok) this.rows = response.rows;
        return this.rows;
      }
    }

    let notif = new Notification();
    await notif.get();

    const nombreDeSecondeAvantRelance = 10;

    async function ping() {
      if (Store.get("pingRunning")) return;
      Store.set("pingRunning", true);

      await Store.get("notification").get();
      Store.get("routeurNotifRun")(Store.get("notification").rows);

      await new Promise((r) =>
        setTimeout(r, nombreDeSecondeAvantRelance * 1000)
      );

      Store.set("pingRunning", false);
      ping();
    }

    Store.set("pingRunning",  false);
    Store.set("notification", notif);
    Store.set("ping", ping);
    Store.get("ping")();

    const app = createApp({
      data: function () {
        return {
          rows: [],
          selector: null,
          selectorxs: null,
          bsOffcanvas: null,
          isEmptyNotification: false,
          isReadNotification: false,
          types: {
            order: { icon: "basket-shopping", color: "primary" },
            user:  { icon: "user", color: "warning" },
            other: { icon: "fa-duotone fa-quote-left", color: "primary" },
          },
        };
      },
      watch: {
        // notifs() {
        //   return this.rows;
        // }
      },
      methods: {
        toIcon(item) {
          if (!item || !this.types[item]) item = "other";
          return `fa-light fa-${this.types[item].icon}`;
        },

        toColor(item) {
          if (!item || !this.types[item]) item = "other";

          const text = this.types[item].color;
          const bg = this.types[item].color;

          return `text-${text} bg-${bg}-soft`;
        },

        // async testcreate() {
        //   const form = {
        //     k: Date.now().toString(),
        //     from: "Server",
        //     to: "Brand Name",
        //     subject: "Order confirmed",
        //     text: "Order #1234567898 is confirmed",
        //     dateCre: "2021-06-01 11:00:00",
        //     link: "#orderList/orderValidate&_id=" + "6448ede9b4046f6cd030f0cf",
        //     type: "order",
        //     read: false,
        //   };
        //   const response = await Store.get("notification").add(form);
        //   this.data = response;
        //   this.checkNumberOfNotification();
        // },

        async remove(id) {
          const response = await Store.get("notification").remove(id);
          this.rows = response;
          this.checkNumberOfNotification();
        },

        async removeAll() {
          const response = await Store.get("notification").removeAll();
          this.rows = response;
          this.checkNumberOfNotification();
        },

        async update(item) {
          if (item.link) {
            this.bsOffcanvas.hide();
            window.location.href = item.link;
          }

          if (!item.read) {
            const copyItem = { ...item };
            copyItem.read = true;
            const form = {
              k: copyItem.k,
              read: true,
            };
            const response = await Store.get("notification").update(form);
            this.rows = response;
            this.checkNumberOfNotification();
          }
        },

        checkNumberOfNotification() {
          this.selector.style.display = "none";
          this.selectorxs.style.display = "none";
          //
          this.isEmptyNotification = this.rows.length === 0;
          this.isReadNotification = this.rows?.every((item) => item.read);
          //
          if  (this.isEmptyNotification)    this.bsOffcanvas.hide();
          if (!this.isEmptyNotification && !this.isReadNotification)   this.selector.style.display = "block";
          if (!this.isEmptyNotification && !this.isReadNotification) this.selectorxs.style.display = "block";

          let numberOfUnreadNotifications = 0;
          for (const i of this.rows) if (!i.read) numberOfUnreadNotifications++;

          this.selector.innerText   = numberOfUnreadNotifications;
          this.selectorxs.innerText = numberOfUnreadNotifications;
        },

        updateTableNotification(rows) {
          this.rows = rows;
          this.checkNumberOfNotification();
        },

        toDate: function (a) {
          return toDate(a);
        },
      },

      mounted() {
        /* TEST */
        // const ctx = {
        //   k: "PDF",
        //   v: "has been generated",
        //   link: "http://google.fr",
        //   doc: {}
        // }
        // AlertNotification({ status: 'success', ctx })
        // AlertNotification({ delay: 3000, status: 'error', ctx })

        this.rows = notif.rows;

        this.selector = document.querySelector(
          "._activeSidebarOffcanvasActivity"
        );

        this.selectorxs = document.querySelector(
          "._activeSidebarOffcanvasActivity-xs"
        );

        this.bsOffcanvas = new Offcanvas(
          document.getElementById("sidebarOffcanvasActivity"),
          {
            toggle: false,
          }
        );
        this.checkNumberOfNotification();
      },
    });

    this.vm = app.mount(THIS.c$("._vueChargement")[0]);

    function routeurNotifRun(rows) {
      let arr = Store.get("routeurNotifAdd") || [];
      for (const fonction of arr) {
        fonction(rows);
      }
    }

    Store.set("routeurNotifAdd", []);
    Store.get("routeurNotifAdd").push(this.vm.updateTableNotification);
    Store.set("routeurNotifRun", routeurNotifRun);
  },
};

export default {
  notifications: { js: js, html: html },
};
